import { PartnerBucketGroupMinMaxPrice } from "../../../interfaces/partner.interface";

// Canonical in-person AMEX bucket (PC-358 / PC-757): 3.3% purchase price,
// range 3.3%–4%. AMEX is ALWAYS a Percentage. Reuse this single constant on
// every in-person pricing surface so a legacy/absent AMEX bucket still renders
// with the correct unit and default instead of disappearing or showing "€".
export const DEFAULT_AMEX_BUCKET: PartnerBucketGroupMinMaxPrice = {
  value: 3.3,
  valueType: "Percentage",
  max: 4,
};
